import GallerySkeleton from './gallery-skeleton'

export default GallerySkeleton
